import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DashboardMetricListPage from '../components/dashboard/DashboardMetricListPage';

function useMetricPeriodParams() {
  const [searchParams] = useSearchParams();
  const year = searchParams.get('year');
  const month = searchParams.get('month');
  const hasYearMonth = year && month;
  const period = hasYearMonth || searchParams.get('period') === 'month' ? 'month' : 'today';
  return { year, month, hasYearMonth, period };
}

const DashboardMetricCanceledNoReturn = () => {
  const { t } = useTranslation();
  const { year, month, hasYearMonth, period } = useMetricPeriodParams();

  const apiPath = useMemo(() => {
    if (hasYearMonth) {
      return `/api/dashboard/metrics/canceled-no-return?year=${year}&month=${month}`;
    }
    return `/api/dashboard/metrics/canceled-no-return?period=${period}`;
  }, [hasYearMonth, year, month, period]);

  const title = period === 'month'
    ? t('dashboard.activity.canceledMonthTitle')
    : t('dashboard.activity.canceledTodayTitle');

  const subtitle = period === 'month'
    ? (hasYearMonth
      ? t('dashboard.activity.canceledMonthSelectedSubtitle', { year, month })
      : t('dashboard.activity.canceledMonthSubtitle'))
    : t('dashboard.activity.canceledTodaySubtitle');

  return (
    <DashboardMetricListPage
      apiPath={apiPath}
      title={title}
      subtitle={subtitle}
      countLabel={t('dashboard.activity.totalCanceledNoReturn')}
      emptyMessage={t('dashboard.activity.noCanceledNoReturn')}
      loadFailedMessage={t('dashboard.activity.loadCanceledFailed')}
      requiredPermissions={['view_dashboard_today', 'view_dashboard_monthly_cancellations']}
    />
  );
};

export default DashboardMetricCanceledNoReturn;
